// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageNotFound_page_not_fount_container__fbtZO {
  width: 865px;
  padding: 15px;
  color: var(--color-font-10);
  overflow: scroll;
  margin-right: auto;
  margin-left: auto;
}
.PageNotFound_page_not_fount_text__oSyt8 {
  text-align: center;
  margin-top: 300px;
  text-transform: uppercase;
  font-size: 24px;
  color: var(--color-theme-silver);
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/PageNotFound/PageNotFound.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gCAAgC;AAClC","sourcesContent":[".page_not_fount_container {\n  width: 865px;\n  padding: 15px;\n  color: var(--color-font-10);\n  overflow: scroll;\n  margin-right: auto;\n  margin-left: auto;\n}\n.page_not_fount_text {\n  text-align: center;\n  margin-top: 300px;\n  text-transform: uppercase;\n  font-size: 24px;\n  color: var(--color-theme-silver);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page_not_fount_container": `PageNotFound_page_not_fount_container__fbtZO`,
	"page_not_fount_text": `PageNotFound_page_not_fount_text__oSyt8`
};
export default ___CSS_LOADER_EXPORT___;
